import React, { useState } from "react";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";

import DirectorDetailsForm from "./DirectorDetailsForm";

const DirectorDetailsTabs = ({ directorsData }) => {
    const [activeTab, setActiveTab] = useState(0);

    const toggleTab = (index) => {
        if (activeTab !== index) setActiveTab(index);
    };

    return (
        <div>
            <Nav>
                {directorsData.map((director, index) => (
                    <NavItem key={index}>
                        <NavLink
                            onClick={() => toggleTab(index)}
                            style={{
                                cursor: "pointer",
                                fontSize: "0.875rem",
                                fontWeight: activeTab === index ? "500" : "400",
                                color: activeTab === index ? "#2B2C2D" : "#2B2C2D",
                                borderBottom:
                                    activeTab === index
                                        ? "3px solid #CC9C58"
                                        : "3px solid transparent"
                            }}
                        >
                            Director {index + 1}
                        </NavLink>
                    </NavItem>
                ))}
            </Nav>

            <TabContent activeTab={activeTab}>
                {directorsData.map((director, index) => (
                    <TabPane tabId={index} key={index}>
                        {activeTab === index && <DirectorDetailsForm directorData={director} />}
                    </TabPane>
                ))}
            </TabContent>
        </div>
    );
};

export default DirectorDetailsTabs;
